import React from 'react'

const BkFlowStructuredSidebarSkipStepButton = props => {
  const {
    activeEnhancementData,
    activeStep,
    handleContinuePayment,
    hotelLabels,
  } = props

  let renderSkipStepButton = []
  let hasActiveEnhancements = Object.keys(activeEnhancementData).length
  let skipButtonLabel = hotelLabels && hotelLabels.continuePayment ? hotelLabels.continuePayment : 'Continue to Payment'

  if (hasActiveEnhancements) {
    skipButtonLabel = hotelLabels && hotelLabels.makeYourPayment ? hotelLabels.makeYourPayment : 'Make Your Payment'
  }

  if (Number(activeStep) === 1) {
    renderSkipStepButton = (
      <button
        onClick={() => handleContinuePayment(activeStep)}
        className="bk-flow-structured-sidebar__skip-step-btn btn btn-primary"
      >
        {skipButtonLabel}
      </button>
    )
  }

  return renderSkipStepButton
}

export default BkFlowStructuredSidebarSkipStepButton



// WEBPACK FOOTER //
// ./src/components/structure/sidebar/elements/BkFlowStructuredSidebarSkipStepButton.js